import { render, staticRenderFns } from "./RendererForm.vue?vue&type=template&id=3d7c8d00&scoped=true&"
import script from "./RendererForm.vue?vue&type=script&lang=ts&"
export * from "./RendererForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7c8d00",
  null
  
)

export default component.exports